import { RequestDTO } from './Request';
import { RequestFileCategory } from './RequestFileCategory';
import { User } from './User';
import { Counterparty } from '@core/types/Counterparty';
import { Nullable } from '@core/helpers';

export type RequestFile = {
  id: number;
  logisticRequestId: RequestDTO | number;
  catId: RequestFileCategory | number;
  path: string;
  filename: string;
  originFilename: string;
  createdId: Partial<User>;
  fileRealDate?: Nullable<string>;
  version: string; // Версия файла
  documentDate: string; // Дата документа
  documentNumber: string; // Внутренний номер документа
  comment: string; // Комментарий
  xk_doc_number: string; // Внутренний номер документа X-keeper
  actual_version: string; // Актуальная версия
  deleteRequestUserId: Nullable<number>; // Идентификатор пользователя, который просит удалить файл
  createdAt: string; // Дата создания
  updatedAt: string; // Дата обновления
};

export enum DenyActTypeEnum {
  NO_LESSEE = 'no_lessee',
  LESSEE_DENY = 'lessee_deny',
  NO_RELEASE = 'no_release',
  CAR_REVIEW = 'car_review',
}

export type TemplateOfActs = {
  availableBy: Counterparty[];
  id: number;
  name: string;
  document: string;
  url: string;
  originName: string;
  error: string | null;
  active: boolean;
  createdAt: string;
  updatedAt: string;
};

export type TemplatesOfActsPayload = {
  templatesOfActs: TemplateOfActs[];
};

export interface UploadProgress<T> {
  progress: number;
  response?: T | null;
}

/*{
    "123": {
      "obrz_pts_psm": RequestFile[],
      "photo_pl": RequestFile[],
      "obrz_app_k_dl": RequestFile[],
    },
    "456": {
      "photo_pl": RequestFile[]
      "obrz_app_k_dkp": RequestFile[]
    }
  }*/
export interface MainRequestFilesPayload {
  [requestId: RequestDTO['id']]: {
    [fileRenamePrefix: RequestFileCategory['fileRenamePrefix']]: RequestFile[];
  };
}

// look tryToSecureRequestFilePath
export type SecuredRequestFilePath = string;
